const ThemeWrapper = ({children}) => {
  return (
    <section className="max-w-7xl px-4  lg:px-0 mx-auto">
      {children}
    </section>
  )
}

export default ThemeWrapper;